export default "__VITE_ASSET__CCokT9Ch__"